import { app } from '../../../../app';

app.factory('SharingSettingsService', SharingSettingsService);

/** @ngInject */
function SharingSettingsService($resource) {
    
    
    return $resource('app/rest/admin/company/:companyId/corporateServiceSharingSettings', {
        companyId : '@companyId'
    }, {
      
        'getSettings' : {
            method : 'GET',
            
            isArray : false
        },
        'saveSettings' : {
            method : 'PUT'
            
        }
      
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-settings/sharing-settings.service.js